// import mockData from './mockData'
import axios from 'axios'
import XLSX from 'xlsx'
import ModalSupervisor from '@/components/SupervisorUniqueKey/Modal'
import { mapState, mapActions, mapGetters } from 'vuex'
import cashDeskOpenLeaveGuard from '@/mixins/cashDeskOpenLeaveGuard'
import cashDeskMustCloseCashGuard from '@/mixins/cashDeskMustCloseCashGuard'
export default {
    data() {
        return {
            date: '',
            date2: '',
            showCalendar: false,
            showCalendar2: false,
            items: [],
            showing: 0,
            showModal: true,
            showList: false,
            loading: false,
            branchOfficeName: '',
        }
    },
    mixins: [cashDeskOpenLeaveGuard, cashDeskMustCloseCashGuard],
    computed: {
        showItems() {
            switch (this.showing) {
                case 0:
                    if (this.items.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    }
                    return this.items
                case 1:
                    if (this.showTickets.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    } else {
                        this.showSuccessSnack(
                            'No se registran ventas para las fechas indicadas'
                        )
                    }
                    return this.showTickets
                case 2:
                    if (this.showInvoices.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    } else {
                        this.showSuccessSnack(
                            'No se registran ventas para las fechas indicadas'
                        )
                    }
                    return this.showInvoices
                case 3:
                    if (this.showTBK.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    } else {
                        this.showSuccessSnack(
                            'No se registran ventas para las fechas indicadas'
                        )
                    }
                    return this.showTBK
                case 4:
                    if (this.showChecks.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    } else {
                        this.showSuccessSnack(
                            'No se registran ventas para las fechas indicadas'
                        )
                    }
                    return this.showChecks
                case 5:
                    if (this.showCustomerCredit.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    } else {
                        this.showSuccessSnack(
                            'No se registran ventas para las fechas indicadas'
                        )
                    }
                    return this.showCustomerCredit
                case 6:
                    if (this.showInternalConsumption.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    } else {
                        this.showSuccessSnack(
                            'No se registran ventas para las fechas indicadas'
                        )
                    }
                    return this.showInternalConsumption
                case 7:
                    if (this.showEmployeeSales.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    } else {
                        this.showSuccessSnack(
                            'No se registran ventas para las fechas indicadas'
                        )
                    }
                    return this.showEmployeeSales
                case 8:
                    if (this.items.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    }
                    return this.items
                default:
                    if (this.items.length > 0) {
                        this.showSuccessSnack('Reporte cargado exitosamente')
                    }
                    return this.items
            }
        },
        reportName() {
            switch (this.showing) {
                case 0:
                    return 'COMPLETO'
                case 1:
                    return 'BOLETAS'
                case 2:
                    return 'FACTURAS'
                case 3:
                    return 'TRANSBANK'
                case 4:
                    return 'CHEQUES'
                case 5:
                    return 'CREDITO_CLIENTE'
                //case 6:
                //return 'CONSUMO_INTERNO'
                case 7:
                    return 'VENTA_EMPLEADO'
                case 8:
                    return 'NOTA_CREDITO'
                case 9:
                    return 'INGRESO_EGRESO'
                default:
                    return 'COMPLETO'
            }
        },
        showTickets() {
            return this.items.filter(i => i.tipo === 'BOLETA')
        },
        showInvoices() {
            return this.items.filter(i => i.tipo === 'FACTURA')
        },
        showTBK() {
            return this.items.filter(i =>
                ['DÉBITO', 'CRÉDITO'].includes(i.medio_de_pago)
            )
        },
        showChecks() {
            return this.items.filter(i =>
                ['CHEQUE A FECHA', 'CHEQUE AL DÍA'].includes(i.medio_de_pago)
            )
        },
        showInternalConsumption() {
            //this.items[0].tipo_transaccion = "CONSUMO INTERNO"
            return this.items.filter(
                i => i.tipo_transaccion === 'CONSUMO INTERNO'
            )
        },
        showEmployeeSales() {
            // this.items[1].tipo_transaccion = "VENTA EMPLEADO"
            // this.items[2].tipo_transaccion = "VENTA EMPLEADO"
            // this.items[3].tipo_transaccion = "VENTA EMPLEADO"

            return this.items.filter(
                i => i.tipo_transaccion === 'VENTA EMPLEADO'
            )
        },
        showCustomerCredit() {
            return this.items.filter(i =>
                ['CRÉDITO CLIENTE'].includes(i.medio_de_pago)
            )
        },
        calcTotal() {
            return this.showItems.reduce((total, item) => {
                return total + item.total
            }, 0)
        },
        calcPaymentMethodTotal() {
            return this.showItems.reduce((total, item) => {
                return total + item.monto_medio_de_pago
            }, 0)
        },
        printData() {
            let data = []
            let cols = this.headers.map(h => {
                return { name: h.text, key: h.text }
            })
            data[0] = cols.map(col => col.name)
            this.showItems.forEach(item => {
                let row = []
                this.iterator.forEach(h => {
                    row.push(item[h])
                })
                data.push(row)
            })
            let totals = cols.map(c => {
                let val = ''
                switch (c.name) {
                    case 'TOTAL':
                        val = this.calcTotal
                        break
                    case 'MONTO MEDIO DE PAGO':
                        val = this.calcPaymentMethodTotal
                        break
                }
                return val
            })
            data.push(totals)
            return { cols, data }
        },
        iterator() {
            return this.headers.map(h => {
                if (h.text === 'FECHA/HORA') return 'fecha_hora_venta'
                return this.lowerAndUnderscore(h.text)
            })
        },
        excludeHeaders() {
            switch (this.showing) {
                case 0:
                    return ['ENTIDAD FOLIO']
                case 1:
                    return [
                        'TIPO',
                        'RUT CLIENTE',
                        'RAZON SOCIAL CLIENTE',
                        'ENTIDAD FOLIO',
                    ]
                case 2:
                    return ['TIPO', 'ENTIDAD FOLIO']
                case 3:
                    return ['ENTIDAD FOLIO']
                case 4:
                    return ['ENTIDAD FOLIO']
                case 5:
                    return ['ENTIDAD FOLIO']
                case 6:
                    return ['ENTIDAD FOLIO']
                case 7:
                    return ['ENTIDAD FOLIO']
                case 8:
                    return [
                        'ESTADO',
                        'MEDIO DE PAGO',
                        'MONTO MEDIO DE PAGO',
                        'FECHA/HORA',
                    ]
                default:
                    return []
            }
        },
        headers() {
            let headers = [
                'ID',
                'TIPO',
                'FOLIO',
                'ENTIDAD FOLIO',
                'ESTADO',
                'MEDIO DE PAGO',
                'TOTAL',
                'MONTO MEDIO DE PAGO',
                'FECHA/HORA',
                'RUT CLIENTE',
                'RAZON SOCIAL CLIENTE',
            ]
            headers = headers
                .filter(h => !this.excludeHeaders.includes(h))
                .map(h => {
                    return {
                        text: h,
                        value: h,
                    }
                })
            if (this.showing === 9) {
                return this.headerEntryEgress.map(h => {
                    return {
                        text: h,
                        value: h,
                    }
                })
            }
            return headers
        },
        headerEntryEgress() {
            return [
                'ID',
                'NUM CAJA',
                'CAJERO',
                'MOVIMIENTO',
                'MONTO',
                'OBSERVACION',
            ]
        },
        ...mapState('SnackbarModalModule', {
            showSnackbar: 'showSnackbar',
            responseConfirm: 'responseConfirm',
        }),
        ...mapGetters('AuthModule', {
            branchOfficeID: 'branchOfficeID',
            cashDeskID: 'cashDeskID',
        }),
    },
    methods: {
        async fetchBranchOfficeData(id) {
            let route = process.env.VUE_APP_API_ROUTE + `/g_branch_office/${id}`
            let r = await axios.get(route)
            this.branchOfficeName = r.data.name
        },
        formatDate(date) {
            let month = '' + (date.getMonth() + 1)
            let day = '' + date.getDate()
            let year = date.getFullYear()
            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day
            return [year, month, day].join('-')
        },
        async fetchData() {
            this.fetchBranchOfficeData(this.branchOfficeID)
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE + `/pos_sales_summary_report`
            try {
                let response = await axios.post(route, {
                    start_date: this.date,
                    end_date: this.date2,
                    branch_office_id: this.branchOfficeID,
                    pos_cash_desk_id: this.cashDeskID,
                })
                console.log(response.data.length)
                if (
                    response.data.pos_sales_summary_report ||
                    response.data.length === 0
                ) {
                    this.items = []
                    this.showSuccessSnack(
                        'No se registran ventas para las fechas indicadas'
                    )
                    return ` `
                }

                this.items = response.data
                //this.showSuccessSnack('Reporte cargado exitosamente')
            } catch (e) {
                this.showErrorSnack(e.response.data.message)
            }
        },
        async fetchCreditNoteData() {
            this.fetchBranchOfficeData(this.branchOfficeID)
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/sl_sale_credit_note_summary_report`
            try {
                let response = await axios.post(route, {
                    start_date: this.date,
                    end_date: this.date2,
                    branch_office_id: this.branchOfficeID,
                })
                console.log(response, 'response creditnote')
                if (response.data.sl_sale_credit_note_summary_report) {
                    this.items = []
                    this.showSuccessSnack(
                        'No se registran ventas para las fechas indicadas'
                    )
                    return
                }
                this.items = [...response.data]
                this.showSuccessSnack('Reporte cargado exitosamente')
            } catch (e) {
                this.showErrorSnack(e.response.data.message)
            }
        },
        async fetchEntryAndEgress() {
            this.fetchBranchOfficeData(this.branchOfficeID)
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/pos_cash_movement_summary_report`
            try {
                let response = await axios.post(route, {
                    start_date: this.date,
                    end_date: this.date2,
                    branch_office_id: this.branchOfficeID,
                })
                console.log(response, 'response Entry Egress')
                if (response.data.pos_cash_movement_summary_report) {
                    this.items = []
                    this.showSuccessSnack(
                        'No se registran ventas para las fechas indicadas'
                    )
                    return
                }
                this.items = [...response.data]
                this.showSuccessSnack('Reporte cargado exitosamente')
            } catch (e) {
                this.showErrorSnack(e.response.data.message)
            }
        },
        fetchInformation() {
            switch (this.showing) {
                case 8:
                    this.fetchCreditNoteData()
                    break
                case 9:
                    this.fetchEntryAndEgress()
                    break
                default:
                    this.fetchData()
                    break
            }
        },
        lowerAndUnderscore(str) {
            return str
                .trim()
                .split(' ')
                .join('_')
                .toLowerCase()
        },
        getTitle(office_name) {
            let date = this.date
            if (this.date !== this.date2) date += `_AL_${this.date2}`
            let title = `REPORTE_VENTA_${
                this.reportName
            }_${office_name}_${date}.xlsx`
            return title
        },
        getXLSX() {
            let sheet = XLSX.utils.json_to_sheet(
                this.printData.data,
                this.printData.cols
            )
            console.log(this.printData.data)
            var new_workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(new_workbook, sheet, 'SheetJS')
            let title = this.getTitle(this.branchOfficeName.toUpperCase() || '')
            XLSX.writeFile(new_workbook, `${title}.xlsx`)
        },
        auth: async function() {
            this.loading = true
            let response = await this.authorize()
            if (response.is_authorized) {
                this.showList = true
                this.loading = false
            } else {
                this.$router.push('/')
            }
        },
        showWaitingSnack(text) {
            this.resetSnackbarState()
            let payloadSnack = this.fillSnack(
                'info',
                text,
                'Espere un momento',
                true
            )
            this.initSnackbar(payloadSnack)
        },
        showSuccessSnack(text) {
            this.resetSnackbarState()
            let payload = {
                typeMessage: 'success',
                message: {
                    title: 'Éxito',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        showErrorSnack(text) {
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            setPermission: 'setPermission',
            setUniqueKey: 'setUniqueKey',
        }),
    },
    components: {
        ModalSupervisor,
    },
    watch: {
        loading(val) {
            if (val) {
                this.showWaitingSnack('Cargando datos, espere un momento')
            } else {
                this.hideSnack()
            }
        },
        showing(val) {
            if (val) {
                this.items = []
            }
        },
    },
    created() {
        this.date = this.formatDate(new Date())
        this.date2 = this.formatDate(new Date())
        this.fetchData()
    },
    mounted: function() {
        this.setPermission(
            this.mixAuthCodePermissions.CREATE_AUTH_POS_DAILY_SALE_REPORT
        )
        document.getElementById('supervisor-modal-button').click()
    },
}
